import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import clx from 'classnames';
import { CalendarPlus, UserPlus } from 'lucide-react';
import { getActiveSalon, getActiveSalonId } from '../../../Auth/store/selectors';
import { modalActions } from '../../../Modals/store';
import useWindowSize from '../../../../utils/useWindowSize';
import { getGreetingKey } from './buildTodayOverview';
import styles from './HomeTodayHero.module.scss';

const HomeTodayHero = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { isMobile } = useWindowSize();
  const salon = useSelector(getActiveSalon());
  const activeSalonId = useSelector(getActiveSalonId());

  const openNewBooking = () => {
    dispatch(
      modalActions.OPEN_MODAL.SUCCESS({
        type: 'addTaskModal',
        props: {},
      }),
    );
  };

  const openNewClient = () => {
    dispatch(
      modalActions.OPEN_MODAL.SUCCESS({
        type: 'createClientModal',
        props: { idsalone: activeSalonId },
      }),
    );
  };

  if (!salon?.name) return null;

  return (
    <section className={clx(styles.hero, { [styles.hero_mobile]: isMobile })}>
      <div className={styles.top}>
        <div className={styles.copy}>
          <h1 className={styles.greeting}>
            {t('home.today.greetingNamed', {
              greeting: t(`home.today.${getGreetingKey()}`),
              name: salon?.name || '',
            })}
          </h1>
        </div>
        <div className={styles.actions}>
          <button type="button" className={styles.ctaSecondary} onClick={openNewClient}>
            <UserPlus size={16} strokeWidth={2.3} />
            <span>{t('home.today.chipClient')}</span>
          </button>
          <button type="button" className={styles.cta} onClick={openNewBooking}>
            <span>{t('home.today.ctaBooking')}</span>
            <CalendarPlus size={16} strokeWidth={2.3} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default HomeTodayHero;
